import { toCsv } from '../../OireachtasPanel/Schedule/oireachtasScheduleModel';

// The program list (Devin 2026-10-19; CSV only, 2026-10-20): every locked
// competition's dancers in the published list order, names and schools only.
// No competitor numbers: those are released the morning of the event. `rows`
// comes from drawModel.programList. UTF-8 with a byte-order mark so Excel
// shows accented names correctly.
export const PROGRAM_CSV_HEADER = ['Code', 'Competition', 'Dancer', 'School'];

export const programListCsv = (rows) =>
  `﻿${toCsv([PROGRAM_CSV_HEADER, ...rows.map((r) => [r.code, r.competition, r.dancer, r.school])])}`;

export const exportProgramList = (rows, filename) => {
  const url = URL.createObjectURL(new Blob([programListCsv(rows)], { type: 'text/csv;charset=utf-8;' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
